// extracted by mini-css-extract-plugin
export default {"border":"Border_border__hGDMZ","border-boderBg":"Border_border-boderBg__PQHZl"};